import { inject } from '@angular/core';
import { ResolveFn, Router } from '@angular/router';
import { Client } from '@df/core/service/client';
import { AntavoService } from '../../antavo/antavo.service';
import { NFirstMission } from './first-mission.component';

/**
 * Resolver to load CMS block and find matching Antavo mission for the first mission page
 */
export const firstMissionResolver: ResolveFn<NFirstMission.IResolverData | void> = async () => {
    const antavoService = inject(AntavoService);
    const router = inject(Router);
    const client = inject(Client);

    const resolverData: NFirstMission.IResolverData = {};

    // Find the specific mission by ID
    const mission = await antavoService.getFirstMission();
    if ((mission && mission.completions !== 1) || client.isCms) {
        resolverData.mission = mission;
    } else {
        console.warn(`First mission not found or already completed`);
        // Redirect if mission not found
        router.navigateByUrl('/account/my-missions');
        return;
    }

    return resolverData;
};
